import { render, staticRenderFns } from "./loginVip.vue?vue&type=template&id=05bf07ca&scoped=true&"
import script from "./loginVip.vue?vue&type=script&lang=js&"
export * from "./loginVip.vue?vue&type=script&lang=js&"
import style0 from "./loginVip.vue?vue&type=style&index=0&id=05bf07ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bf07ca",
  null
  
)

export default component.exports